<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-btn v-if="!hideDrawer" class="mr-3" elevation="1" fab small @click="setDrawer(!drawer)">
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="pageTitle" />

    <v-spacer />
    <!-- Поиска пока нет -->
    <!-- <v-text-field :label="$t('search')" color="secondary" hide-details style="max-width: 165px;">
      <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:append-outer>
        <v-btn class="mt-n2" elevation="1" fab small>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field> -->
    <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="doctorName" />

    <div class="mx-3" />

    <!-- <v-btn
      class="mb-0"
      min-width="0"
      text
      target="_blank"
      :href="$config.VUE_APP_COVIDER_LINK + '/docs/#module=DoctorsPatient'"
      title="Перейти в Covider"
    >
      <v-icon>mdi-open-in-new</v-icon>
    </v-btn> -->
    <v-btn class="mb-0" min-width="0" text to="/patients" title="Сменить пациента">
      <v-icon>mdi-account-injury</v-icon>
    </v-btn>

    <!-- Уведомлений пока нет -->
    <CoreAppBarNotifications></CoreAppBarNotifications>

    <v-menu bottom left offset-y origin="top right" transition="scale-transition" style="z-index: 200">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="mb-0" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <app-bar-item @click="$router.push({ name: 'cabinet' })">
            <v-list-item-title>Личный кабинет</v-list-item-title>
          </app-bar-item>
        </div>
        <div>
          <app-bar-item @click="logout">
            <v-list-item-title>Выход</v-list-item-title>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";
import CoreAppBarNotifications from "./CoreAppBarNotifications.vue";
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  name: "CoreAppBar",

  components: {
    CoreAppBarNotifications,
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  on: { ...this.$listeners },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default,
              );
            },
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    notifications: [],
  }),

  computed: {
    ...mapState(["drawer", "hideDrawer"]),

    pageTitle() {
      if (this.$store.state.pageTitle) {
        return this.$store.state.pageTitle;
      }

      return this.$route.meta && this.$route.meta.title ? this.$t(this.$route.meta.title) : "";
    },
    doctorName() {
      return `${this.$store.state.auth.profile.surname} ${this.$store.state.auth.profile.name} ${
        this.$store.state.auth.profile.patronymic
      }${
        this.$store.state.auth.profile.specializations && this.$store.state.auth.profile.specializations.length
          ? ", " + this.$store.state.auth.profile.specializations[0].localization.specialization_doctor_name.toLowerCase()
          : ""
      }`;
    },
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),

    async logout() {
      this.$store.commit("auth/CLEAR_AUTH");
      await this.$router.push({ path: "/auth/login" });
    },
  },
};
</script>
